function updateFilmFlixPlusPostPreview() {
    const form = document.getElementById('filmflix-plus-post-form');

    if (!form) {
        return;
    }

    const type = form.querySelector('[name="type"]');
    const title = form.querySelector('[name="title"]');
    const excerpt = form.querySelector('[name="excerpt"]');
    const content = form.querySelector('[name="content"]');

    const previewType = document.getElementById('filmflix-plus-preview-type');
    const previewTitle = document.getElementById('filmflix-plus-preview-title');
    const previewExcerpt = document.getElementById('filmflix-plus-preview-excerpt');
    const previewContent = document.getElementById('filmflix-plus-preview-content');

    if (
        !type ||
        !title ||
        !excerpt ||
        !content ||
        !previewType ||
        !previewTitle ||
        !previewExcerpt ||
        !previewContent
    ) {
        return;
    }

    const selectedOption = type.options[type.selectedIndex];

    if (selectedOption) {
        previewType.textContent = selectedOption.textContent.trim();
    }

    previewTitle.textContent =
        title.value.trim() ||
        previewTitle.dataset.placeholder;

    previewExcerpt.textContent =
        excerpt.value.trim() ||
        previewExcerpt.dataset.placeholder;

    previewContent.textContent =
        content.value.trim() ||
        previewContent.dataset.placeholder;
}

document.addEventListener('input', function (event) {
    const form = document.getElementById('filmflix-plus-post-form');

    if (!form || !form.contains(event.target)) {
        return;
    }

    if (
        event.target.matches('[name="title"]') ||
        event.target.matches('[name="excerpt"]') ||
        event.target.matches('[name="content"]')
    ) {
        updateFilmFlixPlusPostPreview();
    }
});

document.addEventListener('change', function (event) {
    const form = document.getElementById('filmflix-plus-post-form');

    if (!form || !form.contains(event.target)) {
        return;
    }

    if (event.target.matches('[name="type"]')) {
        updateFilmFlixPlusPostPreview();
    }

    if (event.target.matches('[name="image"]')) {
        const file = event.target.files && event.target.files[0];

        if (!file) {
            return;
        }

        const previewImage = document.getElementById(
            'filmflix-plus-preview-image'
        );

        const previewImageWrapper = document.getElementById(
            'filmflix-plus-preview-image-wrapper'
        );

        if (!previewImage || !previewImageWrapper) {
            return;
        }

        const reader = new FileReader();

        reader.onload = function (readerEvent) {
            previewImage.src = readerEvent.target.result;
            previewImageWrapper.classList.remove('d-none');
        };

        reader.readAsDataURL(file);
    }
});

window.addEventListener(
    'load',
    updateFilmFlixPlusPostPreview
);

window.addEventListener(
    'pageshow',
    updateFilmFlixPlusPostPreview
);